import { Box, Card, Container, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import registerIllustration from 'assets/register_illustration.svg';
import MHidden from 'components/@material-extend/MHidden/MHidden';
import RegisterForm from 'components/auth/Register/RegisterForm';
import Page from 'components/Page/Page';
import useLocales from 'hooks/useLocales';
import AuthLayout from 'layouts/AuthLayout';
import { PATH_AUTH } from 'routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
    },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
    width: '100%',
    maxWidth: 464,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const Register: React.FunctionComponent = () => {
    const { translate } = useLocales();

    return (
        <RootStyle title={`${translate('register')} | CodeAcademy Kids`}>
            <AuthLayout />

            <MHidden width='mdDown'>
                <SectionStyle>
                    <img src={registerIllustration} alt={translate('register_illustration')} />
                </SectionStyle>
            </MHidden>

            <Container>
                <ContentStyle>
                    <Box sx={{ mb: 5 }}>
                        <Typography variant='h3' gutterBottom>
                            {translate('registration_form_title')}
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }}>
                            {translate('registration_form_subtitle')}
                        </Typography>
                    </Box>

                    <RegisterForm />

                    <Typography variant='body2' align='center' sx={{ color: 'text.secondary', mt: 3 }}>
                        {translate('by_registering_agree')}&nbsp;
                        <Link
                            underline='always'
                            sx={{ color: 'text.primary' }}
                            component='a'
                            href='https://www.codeacademykids.com/privatumo-politika/'
                            target='_blank'
                        >
                            {translate('privacy_policy')}
                        </Link>
                        .
                    </Typography>

                    <Typography variant='body2' align='center' sx={{ mt: 3 }}>
                        {translate('already_have_account')}&nbsp;
                        <Link to={PATH_AUTH.login} variant='subtitle2' component={RouterLink}>
                            {translate('link_to_login_text')}
                        </Link>
                    </Typography>
                </ContentStyle>
            </Container>
        </RootStyle>
    );
};

export default Register;
